import {Space} from "antd";
import {useFormContext} from "react-hook-form";
import {IS_PWYW_ENABLED} from "../../../../services/config";
import {ProductCurrenciesFormField} from "./currencies";
import {PwywCurrenciesFormField} from "../../general/pricing/pwyw-currencies";
import {ProductSubPricingFormFields} from "./sub-pricing";
import {ProductPricingFormFieldsType} from "./types";

export function ProductPricingFormFields() {
  const {watch} = useFormContext<ProductPricingFormFieldsType>();
  const isPayWhatYouWant = IS_PWYW_ENABLED && watch("priceType") === "pwyw";

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <ProductSubPricingFormFields />
      {isPayWhatYouWant ? (
        <PwywCurrenciesFormField />
      ) : (
        <ProductCurrenciesFormField
          id="productPrice"
          label="Default price"
          placeholder="100"
        />
      )}
    </Space>
  );
}
